import React, { useEffect, useState, useRef } from "react";
import PaymentPageHeader from "../../Component/PaymentPageHeader/PaymentPageHeader.jsx";
import PaymentPageSidebar from "../../Component/PaymentPageSidebar/PaymentPageSidebar.jsx";
import Footer from "../../Component/Footer/Footer.jsx";
import MobilePrepaidService from "./MobilePrepaidService.js";
import { API_BASEURLICON } from "../../Config.js";
import { WALLET_TYPE } from "../../Constant.js";
import { useNavigate } from "react-router-dom";
import { SERVICE_ICONS } from "../../Constant.js";
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ApiCalling from "../../ApiServices/ApiCalling.js";
import { ServiceContext } from "../../ServiceContext.js";
import { useContext } from "react";

const MobilePrepaid = ({ serviceID }) => {
  const [showServiceDropdown, setShowServiceDropdown] = useState(false);
  const getOpTypeData = useContext(ServiceContext);
  const scrollRef = useRef(null);
  const [getBannerOpTypeValue, setBannerOpTypeValue] = useState();
  const [serviceSearch, setServiceSearch] = useState("");
  const tabRefs = useRef({});

  const location = useLocation();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".search-service-wrapper")) {
        setShowServiceDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const navigation = performance.getEntriesByType("navigation")[0];
    if (navigation?.type === "reload") {
      sessionStorage.removeItem("pgRedirectedFrom");
    }
  }, []);

  useEffect(() => {
    const scrollToKey = sessionStorage.getItem("scrollToTab");
    if (!scrollToKey) return;
    if (!getOpTypeData || getOpTypeData.length === 0) return;
    if (!scrollRef.current) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const tabEl = tabRefs.current[scrollToKey];
        const container = scrollRef.current;

        if (!tabEl || !container) {
          console.log("tabEl ya container nahi mila");
          return;
        }

        const scrollTo =
          tabEl.offsetLeft - container.clientWidth / 2 + tabEl.offsetWidth / 2;

        console.log("scrollTo:", scrollTo);
        container.scrollTo({ left: scrollTo, behavior: "smooth" });
        sessionStorage.removeItem("scrollToTab");
      });
    });
  }, [location.pathname, getOpTypeData]);

  const handleServiceSearch = () => {
    if (!serviceSearch) return;

    const found = getOpTypeData?.find((item) =>
      item.name.toLowerCase().includes(serviceSearch.toLowerCase()),
    );

    if (found) {
      const nameSlug = found.name.replace(/\s+/g, "").toLowerCase();
      const serviceSlug =
        serviceTypeSlugMap[found.serviceTypeID] || "otherservice";
      const key = `${serviceSlug}-${nameSlug}`;

      sessionStorage.setItem("scrollToTab", key);

      navigate(`/${serviceSlug}/${nameSlug}`);
    }
  };

  useEffect(() => {
    const dthService = getOpTypeData?.find((item) => item.serviceID === 1);

    if (dthService?.serviceID) {
      getBannerOpType(dthService.serviceID);
    }
  }, [getOpTypeData]);

  const getBannerOpType = async (serviceID) => {
    try {
      const bodyObject = {
        OpType: serviceID,
      };

      const res = await ApiCalling.request(
        "POST",
        "/GetBanner",
        bodyObject,
        null,
      );

      if (res?.statuscode === 1) {
        setBannerOpTypeValue(res);
      } else {
        console.error(res?.msg);
      }
    } catch (err) {
      console.error("Error getBannerOpType:", err);
    }
  };

  const bannerList = getBannerOpTypeValue?.bannerUrl || [];

  const serviceTypeSlugMap = {
    1: "recharge",
    11: "billpayment",
  };

  const scrollAmount = 230;

  const scrollLeft = () => {
    scrollRef.current.scrollBy({
      left: -scrollAmount,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({
      left: scrollAmount,
      behavior: "smooth",
    });
  };

  const {
    getNumberList,
    // getNumData,
    handleChange,
    input,
    getHlrLookupData,
    getRechargePlanData,
    selectedAmount,
    setSelectedAmount,
    oid,
    showPopup,
    setShowPopup,
    handleRechargeClick,
    getBalanceData,
    getDiscountAmtData,
    paymentTransaction,
    successPopup,
    setSuccessPopup,
    getPaymentTransaction,
    getTransactionStatus,
    getPaymentModeData,
    addMoneyPopup,
    getPaymentMode,
    setAddMoneyPopup,
    handleClickGateway,
    paymentGatewayData,
    getBalanceUser,
    rechargeDiscountOffer,
    setInput,
    amountError,
    setOID,
    isRechargeProcess,
    handlePrint,
    closeRechargePopup,
    closeSuccessPopup,
    closeAddMoneyPopup,
    getFilteredList,
  } = MobilePrepaidService(serviceID);
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const rechargeAmount = parseFloat(selectedAmount);
  const isCashback = getDiscountAmtData?.isCashback;
  const cashbackAmount = parseFloat(getDiscountAmtData?.cashbackAmount || 0);

  const amountToPay = isCashback
    ? rechargeAmount
    : rechargeAmount - cashbackAmount;

  const walletBalance = parseFloat(getBalanceData?.balance || 0);
  const useFromWallet =
    walletBalance >= amountToPay ? amountToPay : walletBalance;

  const remainingToPay = amountToPay - useFromWallet;
  const remainingToEnterAmount = Math.ceil(remainingToPay);

  const operatorList = getPaymentModeData || [];
  const isSingleOperator = operatorList?.length === 1;
  const isMultipleOperators = operatorList.length > 1;

  const payButtonRef = useRef(null);
  const [isAutoTriggerFromSession, setIsAutoTriggerFromSession] =
    useState(false);
  const [payLoading, setPayLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const justLoggedIn = sessionStorage.getItem("justLoggedIn");
    const pending = sessionStorage.getItem("pendingRecharge");
    const transactionPending = sessionStorage.getItem("pgRedirectedFrom");

    if (justLoggedIn && pending) {
      const { mobile, amount } = JSON.parse(pending);

      setSelectedAmount(amount);
      setInput((prev) => ({ ...prev, Mobile: mobile }));
      setShowPopup(true);
      rechargeDiscountOffer(amount);
      getBalanceUser();

      sessionStorage.removeItem("justLoggedIn");
      sessionStorage.removeItem("pendingRecharge");
    }
    if (transactionPending) {
      const { mobile, amount, oid: storedOid } = JSON.parse(transactionPending);
      setSelectedAmount(amount);
      setInput((prev) => ({ ...prev, Mobile: mobile }));
      setOID(storedOid);
      setShowPopup(true);
      rechargeDiscountOffer(amount, storedOid);
      getBalanceUser();
      setIsAutoTriggerFromSession(true);
      sessionStorage.removeItem("pgRedirectedFrom");
    }
  }, []);

  useEffect(() => {
    if (showPopup && isAutoTriggerFromSession) {
      const timer = setTimeout(() => {
        payButtonRef.current?.click();
        setIsAutoTriggerFromSession(false);
        // ✅ Reset flag after trigger
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showPopup, isAutoTriggerFromSession]);

  //////////// CODE OF PAYMENT GATEWAY FOR PAYTM TRANSACTION //////////////
  useEffect(() => {
    const handlePaytm = async () => {
      try {
        await startPaytmPayment(paymentGatewayData.paytmJSRequest);
      } catch (err) {
        console.error("Paytm error on first load:", err);
      }
    };

    if (
      paymentGatewayData?.type === "paytm" &&
      paymentGatewayData?.paytmJSRequest?.token
    ) {
      handlePaytm(); // ⬅️ Call via async wrapper to await
    }

    if (
      paymentGatewayData?.type === "razorpay" &&
      paymentGatewayData?.razorData
    ) {
      startRazorpayPayment(paymentGatewayData.razorData);
    }
  }, [paymentGatewayData]);

  const loadPaytmScript = (mid) => {
    return new Promise((resolve, reject) => {
      if (window.Paytm?.CheckoutJS) {
        return resolve(window.Paytm);
      }

      const existingScript = document.querySelector(`#paytm-script-${mid}`);
      if (existingScript) {
        waitForCheckoutJS(resolve, reject);
        return;
      }

      const script = document.createElement("script");
      script.id = `paytm-script-${mid}`;
      script.src = `https://securegw.paytm.in/merchantpgpui/checkoutjs/merchants/${mid}.js`;
      script.crossOrigin = "anonymous";

      script.onload = () => {
        waitForCheckoutJS(resolve, reject);
      };

      script.onerror = () => reject("Failed to load Paytm SDK");
      document.body.appendChild(script);
    });
  };

  // ⏳ Helper to wait until Paytm.CheckoutJS is ready
  const waitForCheckoutJS = (resolve, reject, attempts = 10) => {
    const interval = setInterval(() => {
      if (window.Paytm?.CheckoutJS) {
        clearInterval(interval);
        resolve(window.Paytm);
      } else if (attempts <= 0) {
        clearInterval(interval);
        reject("Paytm SDK loaded but CheckoutJS not available after waiting");
      }
      attempts--;
    }, 300); // check every 300ms
  };

  const startPaytmPayment = async (paytmData) => {
    const { mid, orderID, token, amount } = paytmData;

    try {
      const Paytm = await loadPaytmScript(mid);

      const config = {
        root: "",
        flow: "DEFAULT",
        data: {
          orderId: orderID,
          token: token,
          tokenType: "TXN_TOKEN",
          amount: amount,
        },
        handler: {
          notifyMerchant: function (eventName, data) {
            console.log("Paytm Event:", eventName, data);
          },
        },
      };

      await Paytm.CheckoutJS.init(config);
      Paytm.CheckoutJS.invoke();
    } catch (err) {
      console.error("Paytm load/init error:", err);
    }
  };

  //////////// CODE OF PAYMENT GATEWAY FOR PAYTM TRANSACTION //////////////

  //////////// CODE OF PAYMENT GATEWAY FOR RAZORPAY TRANSACTION //////////////

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) return resolve(true);
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const startRazorpayPayment = async (data) => {
    const loaded = await loadRazorpayScript();
    if (!loaded) {
      alert(
        "Failed to load Razorpay SDK. Please check your internet connection.",
      );
      return;
    }

    const options = {
      key: data?.keyId,
      amount: data?.amount,
      currency: "INR",
      name: data?.merchantName || "Merchant",
      description: "Transaction",
      order_id: data?.orderId,
      handler: function (response) {
        console.log("Razorpay success", response);
      },
      prefill: {
        name: data?.customerName,
        email: data?.email,
        contact: data?.mobile,
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  //////////// CODE OF PAYMENT GATEWAY FOR RAZORPAY TRANSACTION //////////////
  const isPlanLoaded = getRechargePlanData && getRechargePlanData.length > 0;

  return (
    <>
      <PaymentPageHeader />
      <div className="main-container">
        <div className="main-wrapper">
          <PaymentPageSidebar />
          <div className="main-content ">
            <div
              style={{
                padding: "10px 0px",
                display: "flex",
                gap: "10px",
                position: "relative",
              }}
            >
              <input
                type="text"
                placeholder="Search Service..."
                value={serviceSearch}
                onChange={(e) => {
                  setServiceSearch(e.target.value);
                  setShowServiceDropdown(e.target.value.trim().length > 0);
                }}
                onFocus={() => {
                  if (serviceSearch.trim()) setShowServiceDropdown(true);
                }}
                style={{
                  flex: 1,
                  padding: "8px 12px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
                autoComplete="off"
              />

              {showServiceDropdown &&
                (() => {
                  const filtered = getOpTypeData?.filter((item) =>
                    item.name
                      .toLowerCase()
                      .includes(serviceSearch.toLowerCase()),
                  );
                  return filtered?.length > 0 ? (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: "70px",
                        background: "#fff",
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        zIndex: 9999,
                        maxHeight: "220px",
                        overflowY: "auto",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      }}
                    >
                      {filtered.map((item, index) => {
                        const serviceSlug =
                          serviceTypeSlugMap[item.serviceTypeID] ||
                          "otherservice";
                        const nameSlug = item.name
                          .replace(/\s+/g, "")
                          .toLowerCase();
                        const iconKey = item?.name.replace(/\s+/g, "");
                        const icon =
                          SERVICE_ICONS[iconKey] || SERVICE_ICONS["GiftCards"];

                        return (
                          <div
                            key={index}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              setServiceSearch(item.name);
                              setShowServiceDropdown(false);

                              const key = `${serviceSlug}-${nameSlug}`;

                              sessionStorage.setItem("scrollToTab", key);

                              navigate(`/${serviceSlug}/${nameSlug}`);
                            }}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              padding: "9px 14px",
                              cursor: "pointer",
                              fontSize: "14px",
                              borderBottom: "1px solid #f0f0f0",
                              backgroundColor: "#fff",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#f5f5f5")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor = "#fff")
                            }
                          >
                            <img
                              src={icon}
                              alt={item.name}
                              style={{ width: "24px", height: "24px" }}
                            />
                            <span style={{ flex: 1 }}>{item.name}</span>
                            <span
                              style={{
                                fontSize: "11px",
                                padding: "2px 8px",
                                borderRadius: "20px",
                                background: "#e6f1fb",
                                color: "#185fa5",
                              }}
                            >
                              {item.serviceTypeID === 1
                                ? "recharge"
                                : "billpayment"}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  ) : null;
                })()}

              <button
                type="button"
                onClick={() => {
                  handleServiceSearch();
                  setShowServiceDropdown(false);
                }}
                style={{
                  padding: "13px 16px",
                  borderRadius: "0px 6px 6px 0",
                  border: "none",
                  background: "rgb(0 119 182)",
                  color: "#fff",
                  cursor: "pointer",
                  position: "absolute",
                  right: "0",
                }}
              >
                Search
              </button>
            </div>
            <div className="main-content-1 bg-dark ">
              <div className="tab-scroller border rounded position-relative">
                <div
                  className="tab-scroller-arrow left-arrow"
                  onClick={scrollLeft}
                >
                  <img
                    src="assets/pwa-static/pwa/images/svg/arrow-left-svgrepo-com.svg"
                    width="18"
                  />
                </div>

                <ul
                  ref={scrollRef}
                  className="nav nav-pills gap-15"
                  style={{
                    display: "flex",
                    flexWrap: "nowrap",
                    overflowX: "auto",
                    scrollBehavior: "smooth",
                  }}
                >
                  {getOpTypeData?.map((item, index) => {
                    const iconKey = item?.name.replace(/\s+/g, "");
                    const icon =
                      SERVICE_ICONS[iconKey] || SERVICE_ICONS["GiftCards"];

                    const serviceSlug =
                      serviceTypeSlugMap[item.serviceTypeID] || "otherservice";

                    const nameSlug = item.name
                      .replace(/\s+/g, "")
                      .toLowerCase();
                    const key = `${serviceSlug}-${nameSlug}`;
                    return (
                      <li className="nav-item" key={index}>
                        <NavLink
                          ref={(el) => (tabRefs.current[key] = el)}
                          to={`/${serviceSlug}/${nameSlug}`}
                          className={`nav-link ${
                            location.pathname === `/${serviceSlug}/${nameSlug}`
                              ? "active-tab"
                              : ""
                          }`}
                        >
                          <div>
                            <img src={icon} alt={item?.name} />
                          </div>
                          <span className="service-name">{item?.name}</span>
                        </NavLink>
                      </li>
                    );
                  })}
                </ul>

                <div
                  className="tab-scroller-arrow right-arrow"
                  onClick={scrollRight}
                >
                  <img
                    src="assets/pwa-static/pwa/images/svg/arrow-right-svgrepo-com.svg"
                    width="18"
                  />
                </div>
              </div>
            </div>
            <div className="main-content-1 cus-main-content-2">
              <div className="categorydetails-page">
                <div className="desktop-operators-main-header-dth  cus-desk-058">
                  

                  <div className="desktop-header-text">
                    <div className="main-heading">Let's Get Your</div>
                    <div className="sub-heading">Mobile Recharge Done!</div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 mt-3">
                    <form className="cus-form-pad cus-pt-12">
                      <div className="accountdetails-form">
                        <div className="accountdetails-field-wrapper ">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper accountdetails-field error">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <label
                                _ngcontent-otk-c11=""
                                className="cus-second-opreator cus-opt-058"
                              >
                                Customer No.
                              </label>
                              <input
                                className="sc-bf9dbd6b-4 erGaQo cus-hgk-input"
                                type="text"
                                name="Mobile"
                                placeholder="Enter Mobile Number"
                                width="100%"
                                value={input?.Mobile}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                        </div>
                        {/* <div className="accountdetails-field-wrapper ">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper accountdetails-field test error">
                            <label
                              _ngcontent-otk-c11=""
                              className="cus-second-opreator cus-opt-058"
                            >
                              Operator
                            </label>
                            <div
                              className="sc-bf9dbd6b-4 erGaQo cus-hgk-input"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                                padding: "8px 12px",
                                backgroundColor: "#fff",
                                height: "50px",
                              }}
                            >
                              <img
                                src={
                                  oid
                                    ? `${API_BASEURLICON}Image/operator/${oid}.png`
                                    : `${API_BASEURLICON}Image/Website/1/favicon.png`
                                }
                                alt=""
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  marginRight: "10px",
                                }}
                              />
                              <span
                                style={{
                                  color: "# rgb(34, 34, 34)",
                                  fontSize: "17px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                           
                                {getHlrLookupData?.operator ? (
                               
                                  <div
                                    className="sc-bf9dbd6b-4 erGaQo cus-hgk-input"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      border: "1px solid #ccc",
                                      borderRadius: "5px",
                                      padding: "8px 12px",
                                      backgroundColor: "#fff",
                                      height: "50px",
                                    }}
                                  >
                                    <img
                                      src={`${API_BASEURLICON}Image/operator/${oid}.png`}
                                      alt=""
                                      style={{
                                        width: "25px",
                                        height: "25px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    <span
                                      style={{
                                        color: "rgb(34,34,34)",
                                        fontSize: "17px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {getHlrLookupData?.operator}
                                    </span>
                                  </div>
                                ) : (
                                  // GetNumberList se dropdown
                                  <select
                                    className="sc-bf9dbd6b-4 erGaQo cus-hgk-input"
                                    style={{
                                      border: "1px solid #ccc",
                                      borderRadius: "5px",
                                      padding: "8px 12px",
                                      backgroundColor: "#fff",
                                      height: "50px",
                                      width: "100%",
                                      fontSize: "15px",
                                    }}
                                    onChange={(e) => setOID(e.target.value)}
                                    value={oid || ""}
                                  >
                                    <option value="">Select Operator</option>
                                    {getFilteredList?.map((item) => (
                                      <option key={item.oid} value={item.oid}>
                                        {item.label}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </span>
                            </div>
                          </div>
                        </div> */}
                        <div className="accountdetails-field-wrapper">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper accountdetails-field test error">
                            <label className="cus-second-opreator cus-opt-058">
                              Operator
                            </label>

                            <div
                              className="sc-bf9dbd6b-4 erGaQo cus-hgk-input"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                                padding: "8px 12px",
                                backgroundColor: "#fff",
                                height: "50px",
                                width: "100%",
                              }}
                            >
                              {/* ⭐ CONDITION START */}

                              {getHlrLookupData?.operator ? (
                                <>
                                  <img
                                    src={`${API_BASEURLICON}Image/operator/${oid}.png`}
                                    alt=""
                                    style={{
                                      width: "25px",
                                      height: "25px",
                                      marginRight: "10px",
                                    }}
                                  />

                                  <span
                                    style={{
                                      color: "rgb(34,34,34)",
                                      fontSize: "17px",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {getHlrLookupData?.operator}
                                  </span>
                                </>
                              ) : (
                                <select
                                  style={{
                                    border: "none",
                                    outline: "none",
                                    background: "transparent",
                                    height: "100%",
                                    width: "100%",
                                    fontSize: "15px",
                                  }}
                                  onChange={(e) => setOID(e.target.value)}
                                  value={oid || ""}
                                >
                                  <option value="">Select Operator</option>
                                  {getFilteredList?.map((item) => (
                                    <option key={item.oid} value={item.oid}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>
                              )}

                              {/* ⭐ CONDITION END */}
                            </div>
                          </div>
                        </div>
                        <div className="accountdetails-field-wrapper last-field cus-last-field">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper accountdetails-field test error">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container ">
                              <label
                                _ngcontent-otk-c11=""
                                className="cus-second-opreator cus-opt-058"
                              >
                                Circle
                              </label>
                              <input
                                className="sc-bf9dbd6b-4 erGaQo cus-hgk-input"
                                type="text"
                                name="circle"
                                placeholder="Circle"
                                width="100%"
                                value={getHlrLookupData?.circle}
                                readOnly
                              />
                            </div>
                          </div>
                        </div>

                        <div className="accountdetails-field-wrapper last-field">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper accountdetails-field test error">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <label
                                _ngcontent-otk-c11=""
                                className="cus-second-opreator cus-opt-058"
                              >
                                Amount
                              </label>
                              <input
                                className="sc-bf9dbd6b-4 erGaQo cus-hgk-input"
                                type="text"
                                name="amount"
                                placeholder="Amount"
                                width="100%"
                                value={selectedAmount}
                                onChange={(e) =>
                                  setSelectedAmount(e.target.value)
                                }
                              />
                              {amountError && (
                                <small
                                  style={{
                                    color: "red",
                                    marginTop: "5px",
                                    display: "block",
                                  }}
                                >
                                  {amountError}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="button-wrapper">
                        <button
                          className="sc-f9b498a8-0 fvwvlb form-submit-btn"
                          width="100%"
                          type="button"
                          onClick={handleRechargeClick}
                          disabled={isRechargeProcess}
                        >
                          {isRechargeProcess ? "Processing.." : "Recharge"}
                        </button>
                      </div>
                    </form>
                  </div>
                  
                  <div className="col-md-6">
{!isPlanLoaded && (
                    <div className="desktop-heading-image">
                      {bannerList.length > 0 && (
                        <img
                          className="cus-electricity-image cus-image-height-02"
                          src={
                            bannerList.length > 0
                              ? bannerList[0].resourceUrl
                              : ""
                          }
                          alt="Mobile Recharge"
                        />
                      )}
                    </div>
                  )}
                  </div>

                  {isPlanLoaded && (
                    <div className="col-md-6 cus-col-7">
                      <div className="billdetails-wrapper">
                        <div className="bill-details-content">
                          <div className="container">
                            <div className="bill-details-head-wrapper cusbill-details">
                              <div className="bill-details-head cus-head-select">
                                Select Plan
                              </div>
                              <div className="flex align-center cus-flex-center">
                                <div className="search-layout-field-wrapper ">
                                  <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper search-layout-input-wrapper cus-input-various">
                                    <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                                      <input
                                        className="cus-input-area"
                                        type="text"
                                        name="search-field"
                                        placeholder="Search for a plan, eg. 199"
                                        width="100%"
                                        data-test-id="input-text-search-field"
                                        value={searchTerm}
                                        onChange={(e) =>
                                          setSearchTerm(e.target.value)
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="container my-5">
                            <div
                              className="scroller scroller-left float-left mt-2"
                              style={{ display: "none" }}
                            >
                              <i className="fa fa-chevron-left"></i>
                            </div>

                            <div
                              className="wrapper-nav"
                              id="test"
                              style={{
                                overflowX: "auto",
                                whiteSpace: "nowrap",
                                WebkitOverflowScrolling: "touch",
                              }}
                            >
                              <ul
                                className="nav nav-tabs list"
                                id="Ul1"
                                role="tablist"
                                style={{
                                  flexWrap: "nowrap",
                                  display: "flex",
                                }}
                              >
                                {getRechargePlanData?.map((item, index) => (
                                  <li
                                    className="nav-item"
                                    role="presentation"
                                    key={index}
                                  >
                                    <a
                                      className={`nav-link ${
                                        index === activeTabIndex ? "active" : ""
                                      }`}
                                      onClick={() => {
                                        setActiveTabIndex(index);
                                        setSearchTerm("");
                                      }}
                                      id={`tab-btn-${index}`}
                                      data-bs-toggle="tab"
                                      data-bs-target={`#tab${index}`}
                                      type="button"
                                      role="tab"
                                      aria-controls={`tab${index}`}
                                      aria-selected={
                                        index === activeTabIndex
                                          ? "true"
                                          : "false"
                                      }
                                    >
                                      {item.pType}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>

                            <div className="swipeable-tabs-wrapper dcc-plan-tabs">
                              <div className="tab-content mt-3" id="Div3">
                                {getRechargePlanData?.map((item, index) => {
                                  const filteredPlans = item.pDetails.filter(
                                    (plan) => {
                                      const desc =
                                        plan.Description || plan.desc || "";
                                      const amount =
                                        plan.Amount || plan.rs || "";
                                      return (
                                        desc
                                          .toLowerCase()
                                          .includes(searchTerm.toLowerCase()) ||
                                        amount.toString().includes(searchTerm)
                                      );
                                    },
                                  );

                                  return (
                                    <div
                                      className={`tab-pane fade ${
                                        index === activeTabIndex
                                          ? "active show"
                                          : ""
                                      }`}
                                      id={`tab${index}`}
                                      role="tabpanel"
                                      aria-labelledby={`tab-btn-${index}`}
                                      key={index}
                                      style={{
                                        maxHeight: "282px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {filteredPlans.map((plan, planIndex) => (
                                        <div
                                          className="plans-card"
                                          key={planIndex}
                                        >
                                          <div className="plan-tag">
                                            {item.pType}
                                          </div>

                                          <div className="plans-features-section">
                                            <div className="plans-features">
                                              <div className="heading">
                                                ₹ {plan.Amount || plan.rs}
                                              </div>
                                              <div className="sub-heading">
                                                {plan.Description || plan.desc}
                                              </div>
                                            </div>
                                            <div className="plans-features">
                                              <div className="heading">
                                                {plan.validity
                                                  ? plan.validity
                                                  : "Validity Not Provided"}
                                              </div>
                                            </div>
                                            <button
                                              className="sc-f9b498a8-0 fvwvlb plan-apply-btn"
                                              width="100%"
                                              type="button"
                                              data-test-id="primaryBtn-plan-apply-btn"
                                              onClick={() =>
                                                setSelectedAmount(
                                                  plan?.Amount || plan?.rs,
                                                )
                                              }
                                            >
                                              APPLY
                                            </button>
                                          </div>

                                          <div className="cost-section no-cost">
                                            <a
                                              className="open-details-popup"
                                              data-test-id="openDetailsPopup"
                                            >
                                              Details
                                            </a>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="pop-up-wrapper swipe-bottom top-rounded-layout">
              <div
                className="pop-up  "
                style={{
                  maxWidth: "50vw",
                  maxHeight: "50vh",
                  minWidth: "50vw",
                  minHeight: "50vh",
                }}
              ></div>
            </div>
            <div className="about-section">
              <div className="content-section" style={{ maxHeight: "100%" }}>
                <h1 data-start="160" data-end="240">
                  <strong data-start="162" data-end="240">
                    Best Prepaid Mobile Recharge Plans in India (2025) – Jio,
                    Airtel, Vi, BSNL
                  </strong>
                </h1>
                <p data-start="284" data-end="659">
                  Pocketvila is a leading digital payment platform offering
                  seamless
                  <strong data-start="351" data-end="387">
                    prepaid mobile recharge services
                  </strong>
                  for all major operators in India, including
                  <strong data-start="432" data-end="477">
                    Jio, Airtel, Vi (Vodafone Idea), and BSNL
                  </strong>
                  . With its
                  <strong data-start="488" data-end="507">
                    fast and secure
                  </strong>
                  recharge process, Freecharge allows you to quickly top up your
                  mobile balance, extend validity, or activate high-speed data
                  packs in just a few clicks.
                </p>
                <p data-start="398" data-end="433">
                  <strong data-start="398" data-end="433">
                    Types of Mobile Recharge Plans:
                  </strong>
                </p>
                <ol data-start="435" data-end="1135">
                  <li data-start="435" data-end="531">
                    <p data-start="438" data-end="531">
                      <strong data-start="438" data-end="455">
                        Top-Up Plans:
                      </strong>
                      Provide a specific talk time balance usable for voice
                      calls, SMS, and data.
                    </p>
                  </li>
                  <li data-start="533" data-end="649">
                    <p data-start="536" data-end="649">
                      <strong data-start="536" data-end="565">
                        Validity Extension Plans:
                      </strong>
                      Extend your mobile number's validity without additional
                      talk time or data benefits.
                    </p>
                  </li>
                  <li data-start="651" data-end="757">
                    <p data-start="654" data-end="757">
                      <strong data-start="654" data-end="670">
                        Combo Plans:
                      </strong>
                      Combine talk time, data, and SMS benefits, ideal for users
                      seeking a balanced package.
                    </p>
                  </li>
                  <li data-start="759" data-end="884">
                    <p data-start="762" data-end="884">
                      <strong data-start="762" data-end="797">
                        Special Tariff Vouchers (STVs):
                      </strong>
                      Offer exclusive benefits like unlimited calling or
                      high-speed data for specific needs.
                    </p>
                  </li>
                  <li data-start="886" data-end="1038">
                    <p data-start="889" data-end="1038">
                      <strong data-start="889" data-end="921">
                        International Roaming Plans:
                      </strong>
                      Provide advantages such as free incoming calls, discounted
                      outgoing calls, and data benefits while traveling abroad.
                    </p>
                  </li>
                  <li data-start="1040" data-end="1135">
                    <p data-start="1043" data-end="1135">
                      <strong data-start="1043" data-end="1068">
                        Value-Added Services:
                      </strong>
                      Include caller tunes, SMS packs, and other supplementary
                      benefits.
                    </p>
                  </li>
                </ol>
                <p data-start="1137" data-end="1199">
                  <strong data-start="1137" data-end="1199">
                    Prepaid Mobile Recharge Operators Available on Freecharge:
                  </strong>
                </p>
                <p data-start="1201" data-end="1276">
                  Pocketvila supports all major prepaid mobile operators in
                  India, including:
                </p>
                <ul data-start="1278" data-end="1339">
                  <li data-start="1278" data-end="1290">
                    <p data-start="1280" data-end="1290">
                      <strong data-start="1280" data-end="1290">
                        Airtel
                      </strong>
                    </p>
                  </li>
                  <li data-start="1292" data-end="1316">
                    <p data-start="1294" data-end="1316">
                      <strong data-start="1294" data-end="1316">
                        Vi (Vodafone Idea)
                      </strong>
                    </p>
                  </li>
                  <li data-start="1318" data-end="1327">
                    <p data-start="1320" data-end="1327">
                      <strong data-start="1320" data-end="1327">
                        Jio
                      </strong>
                    </p>
                  </li>
                  <li data-start="1329" data-end="1339">
                    <p data-start="1331" data-end="1339">
                      <strong data-start="1331" data-end="1339">
                        BSNL
                      </strong>
                    </p>
                  </li>
                </ul>
                <p data-start="1341" data-end="1664">
                  You can browse and select from a wide range of recharge plans,
                  filter them by type or amount, and compare the benefits of
                  different plans. Freecharge also frequently offers exclusive
                  discounts and cashback offers on mobile recharges, making it
                  an even more attractive option for users.
                </p>
                <h3>
                  <strong>Popular Prepaid Mobile Recharge Plans 2025</strong>
                </h3>
                <h4>
                  <strong>1. Jio Prepaid Recharge Plans 2025</strong>
                </h4>
                <p>
                  Jio continues to lead with affordable plans, free 5G access,
                  and bundled OTT subscriptions.
                </p>
                <table className="utility-table">
                  <thead>
                    <tr>
                      <th
                        style={{ border: "1px solid #b0b0b0", padding: "10px" }}
                      >
                        <strong>Plan Price (₹)</strong>
                      </th>
                      <th
                        style={{ border: "1px solid #b0b0b0", padding: "10px" }}
                      >
                        <strong>Validity (Days)</strong>
                      </th>
                      <th
                        style={{ border: "1px solid #b0b0b0", padding: "10px" }}
                      >
                        <strong>Data Per Day (GB)</strong>
                      </th>
                      <th
                        style={{ border: "1px solid #b0b0b0", padding: "10px" }}
                      >
                        <strong>Additional Benefits</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ textAlign: "center" }}>
                    <tr style={{ backgroundColor: "unset" }}>
                      <td
                        style={{
                          border: "1px solid #b0b0b0",
                          fontFamily: "unset",
                        }}
                      >
                        299
                      </td>
                      <td
                        style={{
                          border: "1px solid #b0b0b0",
                          fontFamily: "unset",
                        }}
                      >
                        28
                      </td>
                      <td
                        style={{
                          border: "1px solid #b0b0b0",
                          fontFamily: "unset",
                        }}
                      >
                        2
                      </td>
                      <td
                        style={{
                          border: "1px solid #b0b0b0",
                          fontFamily: "unset",
                        }}
                      >
                        Unlimited calls, 100 SMS/day, JioTV, 5G Data
                      </td>
                    </tr>
                    <tr>
                      <td>399</td>
                      <td>28</td>
                      <td>3</td>
                      <td>Unlimited calls, JioCinema, 5G Data</td>
                    </tr>
                    <tr>
                      <td>666</td>
                      <td>56</td>
                      <td>2</td>
                      <td>Unlimited calls, 100 SMS/day, JioTV</td>
                    </tr>
                    <tr>
                      <td>999</td>
                      <td>84</td>
                      <td>3</td>
                      <td>Netflix Mobile, JioCinema</td>
                    </tr>
                    <tr>
                      <td>2,999</td>
                      <td>365</td>
                      <td>2.5</td>
                      <td>Amazon Prime Lite, JioSaavn</td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  <strong>Insight</strong>: Jio’s ₹399 plan offers the best
                  value with <strong>3GB/day data + free 5G access</strong>.
                </p>
                <hr />
                <h4>
                  <strong>2. Airtel Prepaid Recharge Plans 2025</strong>
                </h4>
                <p>
                  Airtel’s "Truly Unlimited 5G Plans" come with perks like
                  Amazon Prime, Disney+ Hotstar, and Airtel Thanks benefits.
                </p>
                <table className="utility-table">
                  <thead>
                    <tr>
                      <th
                        style={{ border: "1px solid #b0b0b0", padding: "10px" }}
                      >
                        <strong>Plan Price (₹)</strong>
                      </th>
                      <th
                        style={{ border: "1px solid #b0b0b0", padding: "10px" }}
                      >
                        <strong>Validity (Days)</strong>
                      </th>
                      <th
                        style={{ border: "1px solid #b0b0b0", padding: "10px" }}
                      >
                        <strong>Data Per Day (GB)</strong>
                      </th>
                      <th
                        style={{ border: "1px solid #b0b0b0", padding: "10px" }}
                      >
                        <strong>Additional Benefits</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ textAlign: "center" }}>
                    <tr style={{ backgroundColor: "unset" }}>
                      <td
                        style={{
                          border: "1px solid #b0b0b0",
                          fontFamily: "unset",
                        }}
                      >
                        359
                      </td>
                      <td
                        style={{
                          border: "1px solid #b0b0b0",
                          fontFamily: "unset",
                        }}
                      >
                        28
                      </td>
                      <td
                        style={{
                          border: "1px solid #b0b0b0",
                          fontFamily: "unset",
                        }}
                      >
                        2
                      </td>
                      <td
                        style={{
                          border: "1px solid #b0b0b0",
                          fontFamily: "unset",
                        }}
                      >
                        Wynk Music, Unlimited calls
                      </td>
                    </tr>
                    <tr>
                      <td>479</td>
                      <td>56</td>
                      <td>1.5</td>
                      <td>Airtel Thanks rewards</td>
                    </tr>
                    <tr>
                      <td>839</td>
                      <td>84</td>
                      <td>2</td>
                      <td>3-month Amazon Prime</td>
                    </tr>
                    <tr>
                      <td>1,799</td>
                      <td>365</td>
                      <td>2.5</td>
                      <td>Disney+ Hotstar Mobile (1 Year)</td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  <strong>Insight</strong>: Airtel’s ₹1,799 plan is ideal for
                  long-term users with{" "}
                  <strong>1-year Disney+ Hotstar subscription</strong>.
                </p>
                <hr />
                <h4>
                  <strong>
                    3. Vi (Vodafone Idea) Prepaid Recharge Plans 2025
                  </strong>
                </h4>
                <p>
                  Vi offers unique benefits like Weekend Data Rollover and
                  Unlimited Night Data.
                </p>
                <table className="utility-table">
                  <thead>
                    <tr>
                      <th
                        style={{ border: "1px solid #b0b0b0", padding: "10px" }}
                      >
                        <strong>Plan Price (₹)</strong>
                      </th>
                      <th
                        style={{ border: "1px solid #b0b0b0", padding: "10px" }}
                      >
                        <strong>Validity (Days)</strong>
                      </th>
                      <th
                        style={{ border: "1px solid #b0b0b0", padding: "10px" }}
                      >
                        <strong>Data Per Day (GB)</strong>
                      </th>
                      <th
                        style={{ border: "1px solid #b0b0b0", padding: "10px" }}
                      >
                        <strong>Additional Benefits</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ textAlign: "center" }}>
                    <tr style={{ backgroundColor: "unset" }}>
                      <td
                        style={{
                          border: "1px solid #b0b0b0",
                          fontFamily: "unset",
                        }}
                      >
                        479
                      </td>
                      <td
                        style={{
                          border: "1px solid #b0b0b0",
                          fontFamily: "unset",
                        }}
                      >
                        56
                      </td>
                      <td
                        style={{
                          border: "1px solid #b0b0b0",
                          fontFamily: "unset",
                        }}
                      >
                        1.5
                      </td>
                      <td
                        style={{
                          border: "1px solid #b0b0b0",
                          fontFamily: "unset",
                        }}
                      >
                        Unlimited calls, 100 SMS/day, Weekend Data Rollover
                      </td>
                    </tr>
                    <tr>
                      <td>859</td>
                      <td>84</td>
                      <td>2</td>
                      <td>Unlimited night data</td>
                    </tr>
                    <tr>
                      <td>1,099</td>
                      <td>84</td>
                      <td>2</td>
                      <td>3-month Disney+ Hotstar</td>
                    </tr>
                    <tr>
                      <td>2,399</td>
                      <td>365</td>
                      <td>2</td>
                      <td>1-Year Amazon Prime</td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  <strong>Insight</strong>: Vi’s ₹2,399 plan is perfect for
                  heavy users with{" "}
                  <strong>1-year Amazon Prime subscription</strong>.
                </p>
                <hr />
                <h4>
                  <strong>4. BSNL Prepaid Recharge Plans 2025</strong>
                </h4>
                <p>
                  BSNL offers budget-friendly long-term prepaid plans with
                  extended validity.
                </p>
                <table className="utility-table">
                  <thead>
                    <tr>
                      <th
                        style={{ border: "1px solid #b0b0b0", padding: "10px" }}
                      >
                        <strong>Plan Price (₹)</strong>
                      </th>
                      <th
                        style={{ border: "1px solid #b0b0b0", padding: "10px" }}
                      >
                        <strong>Validity (Days)</strong>
                      </th>
                      <th
                        style={{ border: "1px solid #b0b0b0", padding: "10px" }}
                      >
                        <strong>Data Per Day (GB)</strong>
                      </th>
                      <th
                        style={{ border: "1px solid #b0b0b0", padding: "10px" }}
                      >
                        <strong>Additional Benefits</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ textAlign: "center" }}>
                    <tr style={{ backgroundColor: "unset" }}>
                      <td
                        style={{
                          border: "1px solid #b0b0b0",
                          fontFamily: "unset",
                        }}
                      >
                        699
                      </td>
                      <td
                        style={{
                          border: "1px solid #b0b0b0",
                          fontFamily: "unset",
                        }}
                      >
                        180
                      </td>
                      <td
                        style={{
                          border: "1px solid #b0b0b0",
                          fontFamily: "unset",
                        }}
                      >
                        1
                      </td>
                      <td
                        style={{
                          border: "1px solid #b0b0b0",
                          fontFamily: "unset",
                        }}
                      >
                        Unlimited calls, 100 SMS/day
                      </td>
                    </tr>
                    <tr>
                      <td>1,499</td>
                      <td>365</td>
                      <td>2</td>
                      <td>Budget-friendly</td>
                    </tr>
                    <tr>
                      <td>2,399</td>
                      <td>365</td>
                      <td>3</td>
                      <td>Free BSNL Tunes</td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  <strong>Insight</strong>: BSNL’s ₹2,399 plan offers the{" "}
                  <strong>highest daily data (3GB/day)</strong> for long-term
                  users.
                </p>
                <p> </p>
                <p>
                  <img
                    src="data:image/jpeg;base64,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"
                    alt=""
                    width="311"
                    height="163"
                  />
                </p>
                <h2> </h2>
                <p> </p>
                <h2>
                  FAQs on Mobile Prepaid Recharge
                  <br />
                  <br />
                </h2>

                <p>
                  <div
                    className="list-data"
                    // itemscope=""
                    itemType="http://schema.org/FAQPage"
                  >
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          1. What is Top-up Mobile Recharge?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          Top-up Mobile Recharge is a type of prepaid mobile
                          recharge that allows users to add a certain amount of
                          talk time or data to their mobile account.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          2. What is the limit on the amount of mobile recharge?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          The limit on the amount of mobile recharge depends on
                          the service provider and the type of recharge plan
                          chosen by the user.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          3. Is there any limit on the amount of prepaid mobile
                          recharge?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          Yes, there is a limit on the amount of prepaid mobile
                          recharge, which varies based on the service provider
                          and the recharge plan chosen.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          4. How Can I Redeem the Cashback or Offers from
                          Pocketvila?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          To redeem the offers from Pocketvila, users need to
                          download the app and select the offer while making a
                          recharge transaction. The cashback amount will be
                          automatically credited to the users Freecharge wallet.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          5. How to find a suitable mobile recharge for my
                          prepaid mobile number?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          Users can find a suitable mobile recharge for their
                          prepaid mobile number by checking the available
                          recharge plans on the Freecharge app or website. They
                          can compare the plans based on their talk time, data,
                          and validity and choose the one that best fits their
                          needs.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          6. What is the first prepaid recharge plan to activate
                          the prepaid SIM card?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          The first prepaid recharge plan to activate a prepaid
                          SIM card may vary depending on the service provider.
                          Users can check with their service provider for the
                          available options.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          7. What to do if I make a mobile recharge on the wrong
                          number by mistake?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          If a user makes a mobile recharge on the wrong number
                          by mistake, they should contact their service
                          providers customer care immediately to report the
                          issue and request a refund or transfer of the recharge
                          amount.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          8. Can I cancel a mobile recharge?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          Generally, mobile recharge transactions cannot be
                          canceled once they are completed. However, some
                          service providers may have a refund policy in certain
                          cases.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          9. What is the expiry date for prepaid mobile
                          recharge?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          The expiry date for prepaid mobile recharge may vary
                          depending on the recharge plan chosen by the user
                          (like 28 days, 3 months, or a year). Users can check
                          the validity period of their recharge plan on the
                          Freecharge app or website.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          10. Is there any limit to make the number of mobile
                          recharges on a prepaid mobile number?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          Generally, there is no limit on the number of mobiles
                          recharges made. However, there may be a limit to the
                          number of mobile recharges on a prepaid mobile number,
                          which varies depending on the service provider and the
                          recharge plan chosen.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          11. Why Choose Pocketvila For Prepaid Recharge?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          Pocketvila offers a wide range of recharge plans,
                          flexible payment options, fast and secure
                          transactions, and frequent discounts and cashback
                          offers, making it a preferred choice for prepaid
                          recharge.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          12. Is There Any Extra Charge On Mobile Recharge?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          There is no extra charge for mobile recharge. However,
                          some service providers may charge a convenience fee or
                          service charge in certain cases.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          13. Is Online Mobile Recharge Safe?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          Online mobile recharge is generally safe as long as
                          users choose a reliable and secure platform like
                          Freecharge.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          14. By When Can a Mobile Prepaid Recharge Be Done?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          Mobile prepaid recharge can be done anytime as per the
                          validity period of the chosen recharge plan.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          15. Can I Make Mobile Prepaid Recharge Online With A
                          Credit Card?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          Yes, users can make mobile prepaid recharge online
                          with a credit card on platforms like Freecharge.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          16. What Is The Difference Between Prepaid And
                          Postpaid Mobile Plans?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          The main difference between prepaid and postpaid
                          mobile plans is that prepaid plans require users to
                          recharge their account with a certain amount before
                          using the services. In contrast, postpaid plans
                          involve paying a fixed bill at the end of the billing
                          cycle.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          17. Can I Recharge My Friends Mobile Using My Account?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          Yes, users can recharge their friends mobile by using
                          their own account on Freecharge by simply putting
                          their friends number and selecting the right service
                          provider.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          18. How Do I Know If My Mobile Recharge Is Successful?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          Users can check the status of their mobile recharge on
                          the Pocketvila app or website, where they will receive
                          a confirmation message upon successful recharge.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          19. What Should I Do If My Online Mobile Recharge
                          Fails?{" "}
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          If an online mobile recharge fails, users should check
                          their account balance and transaction history, and
                          contact customer support for assistance.
                        </p>
                      </div>
                    </div>
                    <div
                      className="list-item "
                      // itemscope=""
                      itemprop="mainEntity"
                      itemType="http://schema.org/Question"
                    >
                      <div className="faq-question">
                        <h3 itemprop="name text">
                          20. What Is An UPI-Based Mobile Recharge?
                        </h3>
                      </div>
                      <div
                        className="faq-answer"
                        itemprop="acceptedAnswer"
                        // itemscope=""
                        itemType="http://schema.org/Answer"
                      >
                        <p itemprop="text">
                          UPI-based mobile recharge is a type of mobile recharge
                          that uses the Unified Payments Interface (UPI)
                          platform for payment transactions. This type of
                          recharge is fast, secure, and convenient for users.
                          Pocketvila also allows you to pay your mobile
                          recharges via UPI.
                        </p>
                      </div>
                    </div>
                  </div>
                </p>

                <div className="list-data">
                  <div className="list-item ">
                    <div className="faq-question"> </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />

      {showPopup && (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div className="cus-main-xcontainer">
              <div className="close-btn" onClick={closeRechargePopup}>
                ✖
              </div>
              <div className="cus-main-xheader">
                <div className="cus-flex-header">
                  <img src={`${API_BASEURLICON}Image/operator/${oid}.png`} />
                  <p>
                    <strong>{getHlrLookupData?.operator}</strong>
                    <br />
                    {getHlrLookupData?.mobileNo}
                  </p>
                </div>
              </div>

              {Object.keys(WALLET_TYPE)?.map((key) => {
                if (!getBalanceData[key]) return;

                let balanceKey = "";
                if (key === "isBalance") {
                  balanceKey = "balance";
                } else if (key === "isBBalance") {
                  balanceKey = "bBalance";
                } else if (key === "isCBalance") {
                  balanceKey = "cBalance";
                } else if (key === "isUBalance") {
                  balanceKey = "uBalance";
                } else if (key === "isIDBalance") {
                  balanceKey = "idBalnace";
                } else if (key === "isPacakgeBalance") {
                  balanceKey = "pacakgeBalance";
                }

                const amount = getBalanceData[balanceKey];

                return (
                  <div key={key} className="wallet cus-wallet-2">
                    <div>
                      <p>
                        <strong>{WALLET_TYPE[key]}</strong>
                      </p>
                      <p>₹ {amount?.toFixed(2)}</p>
                    </div>
                    <span>
                      <img
                        src="assets/pwa-static/pwa/images/wallet.png"
                        alt="Logo"
                      />
                    </span>
                  </div>
                );
              })}

              <div className="amount-section">
                <div className="recharge-amount">
                  <p>Recharge Amt.</p>
                  <span>₹ {selectedAmount}</span>
                </div>
                {!isCashback && (
                  <div className="recharge-amount">
                    <p>Discount Amt.</p>
                    <span>₹ {cashbackAmount}</span>
                  </div>
                )}
                <div className="recharge-amount">
                  <p>Use Wallet</p>
                  <span>₹ {useFromWallet?.toFixed(2)}</span>
                </div>

                <div className="recharge-amount">
                  <p className="">Remain Amount </p>
                  <span>₹ {remainingToPay?.toFixed(2)}</span>
                </div>
              </div>

              <div
                className="pay-button"
                ref={payButtonRef}
                onClick={async () => {
                  setPayLoading(true); // ✅ Start loader
                  try {
                    if (remainingToPay <= 0) {
                      await paymentTransaction(
                        selectedAmount,
                        oid,
                        getHlrLookupData?.mobileNo,
                      );
                    } else {
                      await getPaymentMode();
                    }
                  } catch (err) {
                    console.error("Payment error:", err);
                  } finally {
                    setPayLoading(false); // ✅ Stop loader
                  }
                }}
              >
                {payLoading ? (
                  <span>
                    <img
                      src="/assets/pwa-static/pwa/images/loader.gif"
                      alt="loading"
                      style={{ width: 20, height: 20, marginRight: 8 }}
                    />
                    Processing...
                  </span>
                ) : remainingToPay > 0 ? (
                  `Pay Securely ₹ ${remainingToPay?.toFixed(2)}`
                ) : (
                  "Pay"
                )}
              </div>

              <div className="note">
                {isCashback && (
                  <div className="cashback-note">
                    <p
                      style={{
                        color: "#007bff",
                        fontSize: "14px",
                        marginTop: "10px",
                        marginBottom: "15px",
                      }}
                    >
                      🎁 You will receive ₹{getDiscountAmtData?.cashbackAmount}
                      &nbsp; as cashback after payment.
                    </p>
                  </div>
                )}

                <p>
                  <strong>Note:</strong> Kindly check once again all information
                  before doing transactions. Otherwise after transaction
                  recharge amount will not reverse.
                </p>
              </div>
            </div>
          </div>
        </>
      )}

      {successPopup && (
        <>
          <div className="bbps-popup-overlay">
            <div class="bbps-wrapper">
              <button className="bbps-close" onClick={closeSuccessPopup}>
                ✕
              </button>
              <div class="bbps-header">
                <div class="bbps-left">
                  <img src={`${API_BASEURLICON}/Image/Website/1/favicon.png`} />
                </div>

                <div class="bbps-right">
                  <img src={`${API_BASEURLICON}/images/bassured.png`} />
                  <img
                    src={`${API_BASEURLICON}/images/bbps.png`}
                    class="bbps-bbps"
                  />
                </div>
              </div>
              <h2 class="bbps-title">Transaction Detail</h2>
              <div class="bbps-table">
                <div class="bbps-row">
                  <div class="bbps-label">Transaction Status</div>
                  <div class="bbps-colon">:</div>

                  <div
                    class={`bbps-value ${
                      getPaymentTransaction?.statuscode == 2
                        ? "success"
                        : getPaymentTransaction?.statuscode == 1
                          ? "pending"
                          : "failed"
                    }`}
                  >
                    {getPaymentTransaction?.statuscode == 2 && "Success"}
                    {getPaymentTransaction?.statuscode == 1 && "Pending"}
                    {getPaymentTransaction?.statuscode == 3 && "Failed"}
                  </div>
                </div>
                <div class="bbps-row">
                  <div class="bbps-label">Transaction Message</div>
                  <div class="bbps-colon">:</div>
                  <div class="bbps-value success">
                    {getPaymentTransaction?.msg}
                  </div>
                </div>

                <div class="bbps-row">
                  <div class="bbps-label"> Transaction ID</div>
                  <div class="bbps-colon">:</div>
                  <div class="bbps-value">
                    {getPaymentTransaction?.liveID || "-"}
                  </div>
                </div>

                <div class="bbps-row">
                  <div class="bbps-label">Provider Name</div>
                  <div class="bbps-colon">:</div>
                  <div class="bbps-value">
                    {getHlrLookupData?.operator || "-"}
                  </div>
                </div>

                <div class="bbps-row">
                  <div class="bbps-label">Mobile Number</div>
                  <div class="bbps-colon">:</div>
                  <div class="bbps-value">
                    {getHlrLookupData?.mobileNo || "-"}
                  </div>
                </div>

                <div class="bbps-row">
                  <div class="bbps-label">Bill/Recharge Amount</div>
                  <div class="bbps-colon">:</div>
                  <div class="bbps-value"> {selectedAmount || "-"}</div>
                </div>
                <div class="bbps-row">
                  <div class="bbps-label">Convenience Fee inclusive of GST</div>
                  <div class="bbps-colon">:</div>
                  <div class="bbps-value"> 0.00</div>
                </div>

                <div class="bbps-row">
                  <div class="bbps-label">Bharat Connect Transaction ID</div>
                  <div class="bbps-colon">:</div>
                  <div class="bbps-value">
                    {getPaymentTransaction?.transactionID || "-"}
                  </div>
                </div>
                <div class="bbps-row">
                  <div class="bbps-label">Date & Time</div>
                  <div class="bbps-colon">:</div>
                  <div class="bbps-value">
                    {new Date().toLocaleString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </div>
                </div>
              </div>
              <p class="bbps-note">
                Your payment will be updated at billers end within 3 to 5
                working days.
              </p>
              <p class="bbps-warning">
                Please note this is not a GST invoice but only a confirmation
                receipt for the amount paid.
              </p>
              <div class="bbps-footer">
                <p>
                  This is a system generated receipt and does not require any
                  signature.
                </p>
              </div>
              <div class="print-button">
                <button onClick={handlePrint}>Print</button>
              </div>
            </div>
          </div>
        </>
      )}
      {addMoneyPopup && (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div className="cus-main-xcontainer">
              <div className="close-btn" onClick={closeAddMoneyPopup}>
                ✖
              </div>
              <div className="cus-main-xheader">
                <div className="cus-flex-header">
                  <h4
                    _ngcontent-ocg-c12=""
                    className="modal-title pull-left title cus-addmoney"
                  >
                    <i
                      _ngcontent-ocg-c12=""
                      aria-hidden="true"
                      className="fa fa-plus"
                    ></i>
                    Add Money to Wallet
                  </h4>
                </div>
              </div>
              <hr className="cus-payment-hr" />
              {Object.keys(WALLET_TYPE)?.map((key) => {
                if (!getBalanceData[key]) return;

                let balanceKey = "";
                if (key === "isBalance") {
                  balanceKey = "balance";
                } else if (key === "isBBalance") {
                  balanceKey = "bBalance";
                } else if (key === "isCBalance") {
                  balanceKey = "cBalance";
                } else if (key === "isUBalance") {
                  balanceKey = "uBalance";
                } else if (key === "isIDBalance") {
                  balanceKey = "idBalnace";
                } else if (key === "isPacakgeBalance") {
                  balanceKey = "pacakgeBalance";
                }

                const amount = getBalanceData[balanceKey];

                return (
                  <div key={key} className="wallet cus-wallet-2">
                    <div>
                      <p>
                        <strong>{WALLET_TYPE[key]}</strong>
                      </p>
                      <p>₹ {amount?.toFixed(2)}</p>
                    </div>
                    <span>
                      <img
                        src="assets/pwa-static/pwa/images/wallet.png"
                        alt="Logo"
                      />
                    </span>
                  </div>
                );
              })}

              <div>
                <p className="warning">
                  Amount to be added in wallet :&nbsp;
                  <span className="info">₹ &nbsp;{remainingToEnterAmount}</span>
                </p>
              </div>

              {isSingleOperator && (
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                  <button
                    type="button"
                    className="pay-button"
                    onClick={() =>
                      handleClickGateway(
                        operatorList[0]?.oid,
                        remainingToEnterAmount,
                      )
                    }
                  >
                    ADD TO WALLET
                  </button>
                </div>
              )}

              {isMultipleOperators && (
                <>
                  <p className="cus-choose-payment">Payment Option</p>
                  <div className="custom_radio">
                    <ul>
                      {operatorList?.map((op) => (
                        <li key={op?.oid}>
                          <div
                            className="cus-px1"
                            onClick={() =>
                              handleClickGateway(
                                op?.oid,
                                remainingToEnterAmount,
                              )
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <div className="col-md-2">
                              <img
                                style={{ width: "37px" }}
                                src={
                                  op?.image
                                    ? op?.image
                                    : `${API_BASEURLICON}Image/operator/${op?.oid}.png`
                                }
                                alt={op?.name}
                              />
                            </div>
                            <div className="col-md-10">
                              <label>{op?.name}</label>
                              <p className="addmoney-charge">
                                Charges: {op?.charge || "0%"}
                              </p>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default MobilePrepaid;
